export function setParametros(state, parametros) {
  state.parametros = parametros;
}
